import Model from '@/dc-it/models/Model'
import Field from '@/dc-it/types/Field'

export default class Ability extends Model {
    endpoint = 'abilities';

    fields = [
      new Field('id', 'Código').disabled(),
      new Field('name', 'Nombre'),
    ];

    clone = () => Ability;
}
